import React from "react";
import MuiDialog from "@mui/material/Dialog";
import MuiButton from "@mui/material/Button";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiReportProblemIcon from "@mui/icons-material/ReportProblem";

// Source
import * as ModelDialog from "../model/Dialog";
import ControllerLocalization from "../controller/Localization";

let isRendered = false;

const viewDialog: React.FC<ModelDialog.Iprops> = (props) => {
    // Variable
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <MuiDialog open={props.isOpen} className={`view_dialog ${props.className}`} data-at_id="view_dialog">
                {(() => {
                    const html: JSX.Element[] = [];
                    html.push(
                        <div className={props.mode}>
                            {(() => {
                                const html: JSX.Element[] = [];

                                if (props.mode == "alert") {
                                    html.push(
                                        <div className="div_icon">
                                            <MuiReportProblemIcon className="icon_report_problem" />
                                        </div>
                                    );
                                }

                                return html;
                            })()}
                            {(() => {
                                const html: JSX.Element[] = [];

                                if (props.mode == "alert" || props.mode == "info") {
                                    html.push(<p className="title">{controllerLocalization.getStorageMain.warning}</p>);
                                }

                                return html;
                            })()}
                            <div className="content">{props.content}</div>
                            <div className="action">
                                <MuiButton
                                    data-at_id="dialog_confirm"
                                    onClick={() => props.onClickConfirm()}
                                    disabled={props.isApiLoading}
                                    className={props.mode == "alert" ? "button_danger" : "button_primary"}
                                >
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (props.isApiLoading) {
                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                        } else {
                                            html.push(<>{props.labelConfirm}</>);
                                        }

                                        return html;
                                    })()}
                                </MuiButton>
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (props.mode == "alert" || props.mode == "info") {
                                        html.push(
                                            <MuiButton
                                                data-at_id="dialog_cancel"
                                                onClick={() => props.onClickCancel(false)}
                                                disabled={props.isApiLoading}
                                                className="button_flat"
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (props.isApiLoading) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(<>{props.labelCancel}</>);
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        );
                                    }

                                    return html;
                                })()}
                            </div>
                        </div>
                    );

                    return html;
                })()}
            </MuiDialog>
        );
    } else {
        return <></>;
    }
};

export default viewDialog;
